// src/integrations/index.js
import enode from './enode/manifest';
import jira from './jira/manifest';
import kempower from './kempower/manifest';
import monta from './monta/manifest';
import smartcar from './smartcar/manifest';

export const INTEGRATION_MANIFESTS = {
  [enode.type]: enode,
  [jira.type]: jira,
  [kempower.type]: kempower,
  [monta.type]: monta,
  [smartcar.type]: smartcar,
};

export function getIntegrationDisplayName(type, fallbackDisplayName) {
  if (fallbackDisplayName) return fallbackDisplayName;
  const manifest = type ? INTEGRATION_MANIFESTS[type] : null;
  return manifest?.displayName || type || 'Integration';
}

export function getIntegrationManifest(type) {
  return type ? INTEGRATION_MANIFESTS[type] : null;
}
